// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3oP-C","info":"UpdateTermsInfo_info__3BLpo"};